import type { GebiedLabel } from '@models/GebiedLabel'

import { apiClient } from '../../gateways/api'

export { deleteLabel }

const deleteLabel = async ({
  label,
}: {
  label: GebiedLabel
}): Promise<void> => {
  await apiClient({
    url: `/rest/label/${label._id}`,
    method: 'DELETE',
  })
}
